(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      /*
        this = <sticky-header> = .header-wrapper (ارتفاعه الحقيقي دايمًا)
        this.header = .section-header — وده بياخد height: 0 في وضع الهيدر
        الشفاف، فلو قرينا منه --header-height هتبقى 0 وهتكسر
        إشعار السلة ووضع "الظهور عند التمرير لأعلى".
      */
      const height = this.offsetHeight || this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((modal) => modal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    /*
      All DOM work happens in connectedCallback, never the constructor.
      The custom element spec forbids a constructor from inspecting children,
      and the previous version threw there on any product page whose markup
      it did not expect - which aborted element upgrade and killed the whole
      component silently.
    */
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.button = this.querySelector('[data-sticky-atc-button]');
      this.label = this.querySelector('[data-sticky-atc-label]');
      this.buttonPrice = this.querySelector('[data-sticky-atc-button-price]');
      this.spinner = this.querySelector('.loading__spinner');
      this.priceHost = this.querySelector('[data-sticky-atc-price]');
      this.thumb = this.querySelector('[data-sticky-atc-image]');
      this.variantHost = this.querySelector('[data-sticky-atc-variant]');

      if (!this.button) return;

      if (this.dataset.buttonShake === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startShake();
      }

      this.isSingleVariant = this.dataset.singleVariant === 'true';

      this.shown = false;
      this.revealAt = 0;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onVariantPick = this.onVariantPick.bind(this);

      /*
        The card layout gives the button far less room than the desktop bar,
        so the merchant can set a shorter label for it. The breakpoint has to
        be watched, not read once: rotating a phone crosses it, and a label
        left over from the other layout either overflows the pill or looks
        oddly terse on desktop.
      */
      this.compactQuery = window.matchMedia('(max-width: 749px)');
      this.onCompactChange = () => {
        this.measure();
        this.syncButton();
        this.update();
      };
      if (typeof this.compactQuery.addEventListener === 'function') {
        this.compactQuery.addEventListener('change', this.onCompactChange);
      }

      this.button.addEventListener('click', this.onClick);
      this.variantHost?.addEventListener('change', this.onVariantPick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      /* The reveal threshold depends on the height of the product form, which
         changes as images load, accordions open and apps inject content. The
         previous version measured it once at construction and never again. */
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.measure();
          this.onScroll();
        });
        const target = this.productForm() || document.body;
        this.resizeObserver.observe(target);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        /* Dawn publishes cartUpdate after a successful add and cartError on
           failure. Both end the local busy state - see setBusy(). */
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.onAddResolved(true));
        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => this.onAddResolved(false));
      }

      this.measure();
      this.syncButton();
      this.update();
    }

    disconnectedCallback() {
      window.clearInterval(this.shakeInterval);
      window.clearTimeout(this.shakeTimeout);
      document.documentElement.classList.remove('t4s-ani-shake');
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
      this.variantHost?.removeEventListener('change', this.onVariantPick);
      this.resizeObserver?.disconnect();
      if (typeof this.compactQuery?.removeEventListener === 'function') {
        this.compactQuery.removeEventListener('change', this.onCompactChange);
      }
      window.clearTimeout(this.busyTimer);
      window.clearTimeout(this.addedTimer);
      if (typeof this.variantUnsubscriber === 'function') this.variantUnsubscriber();
      if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
      if (typeof this.cartErrorUnsubscriber === 'function') this.cartErrorUnsubscriber();
      this.initialised = false;
    }

    startShake() {
      const root = document.documentElement;
      root.classList.add('t4s-ani-shake');
      this.shakeTimeout = window.setTimeout(() => root.classList.remove('t4s-ani-shake'), 1100);
      this.shakeInterval = window.setInterval(() => {
        if (document.hidden) return;
        root.classList.add('t4s-ani-shake');
        window.clearTimeout(this.shakeTimeout);
        this.shakeTimeout = window.setTimeout(() => root.classList.remove('t4s-ani-shake'), 1100);
      }, 6000);
    }

    /* ---------- in-flight feedback ---------- */

    setBusy(busy) {
      if (!this.button) return;
      this.busy = busy;
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.spinner?.classList.toggle('hidden', !busy);

      window.clearTimeout(this.busyTimer);
      if (busy) {
        /* Safety net: if neither cartUpdate nor cartError ever arrives -
           a network stall, or an app that swallows the event - the button
           must not stay stuck as a spinner. */
        this.busyTimer = window.setTimeout(() => this.setBusy(false), 8000);
      }
    }

    onAddResolved(success) {
      if (!this.busy) return;
      this.setBusy(false);
      if (!success || !this.label) return;

      /* Brief confirmation, because the cart drawer may be configured off
         and the header badge is off-screen behind the sticky bar. */
      this.button.classList.add('is-added');
      this.label.textContent = this.dataset.textAdded;
      if (this.buttonPrice) this.buttonPrice.hidden = true;
      window.clearTimeout(this.addedTimer);
      this.addedTimer = window.setTimeout(() => {
        this.button.classList.remove('is-added');
        this.syncButton();
      }, 2000);
    }

    /* ---------- references into the main product section ---------- */

    productForm() {
      return document.querySelector('product-info product-form form[data-type="add-to-cart-form"]')
        || document.querySelector('product-form form[data-type="add-to-cart-form"]');
    }

    mainSubmitButton() {
      const form = this.productForm();
      return form ? form.querySelector('[type="submit"][name="add"]') : null;
    }

    variantPicker() {
      return document.querySelector('variant-selects')
        || document.querySelector('.product-form__input')
        || document.querySelector('product-info')
        || document.querySelector('.product__title');
    }

    footer() {
      /* Cached, but re-queried if the node is gone: section rendering in the
         theme editor replaces the footer element wholesale. */
      if (this.footerEl && this.footerEl.isConnected) return this.footerEl;
      this.footerEl = document.querySelector('.shopify-section-group-footer-group')
        || document.querySelector('#shopify-section-footer')
        || document.querySelector('footer');
      return this.footerEl;
    }

    /* ---------- visibility ---------- */

    measure() {
      if (this.compactQuery?.matches && this.dataset.alwaysVisible === 'true') return;
      const form = this.productForm();
      if (!form) {
        this.revealAt = 0;
        return;
      }
      this.revealAt = form.getBoundingClientRect().bottom + window.scrollY - 300;
    }

    onScroll() {
      if (this.compactQuery?.matches && this.dataset.alwaysVisible === 'true') return;
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      let shouldShow;

      if (this.compactQuery?.matches) {
        if (this.dataset.alwaysVisible === 'true') {
          shouldShow = true;
        } else {
          const mainButton = this.mainSubmitButton();
          const mainButtons = mainButton?.closest('.product-form__buttons') || mainButton;

          if (!mainButtons) {
            shouldShow = true;
          } else {
            const rect = mainButtons.getBoundingClientRect();
            const mainButtonsVisible = rect.top < window.innerHeight && rect.bottom > 0;
            shouldShow = !mainButtonsVisible;
          }
        }
      } else {
        shouldShow = window.scrollY > this.revealAt;
        const footer = this.footer();
        if (shouldShow && footer) {
          const footerTop = footer.getBoundingClientRect().top;
          if (footerTop <= window.innerHeight) shouldShow = false;
        }
      }

      if (shouldShow === this.shown) return;
      this.shown = shouldShow;
      this.classList.toggle('show', shouldShow);
    }

    /* ---------- button state ---------- */

    /*
      The main submit button is the single source of truth for whether the
      current selection is purchasable: Dawn's product-info.js calls
      toggleSubmitButton() on it after every variant change. Mirroring it
      means this component can never disagree with the real buy button.
    */
    syncButton(variant) {
      const main = this.mainSubmitButton();
      const strings = window.variantStrings || {};

      const mainDisabled = main
        ? main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true'
        : false;

      // A multi-variant product whose current combination does not resolve to
      // a purchasable variant: send the shopper to the picker instead of
      // showing them a dead button.
      const needsChoice = !this.isSingleVariant && (variant === null || mainDisabled);

      if (needsChoice) {
        this.mode = 'choose';
        this.button.disabled = false;
        this.button.removeAttribute('aria-disabled');
        if (this.label) this.label.textContent = this.dataset.textChooseOptions;
        if (this.buttonPrice) this.buttonPrice.hidden = true;
        return;
      }

      if (mainDisabled) {
        this.mode = 'disabled';
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        if (this.label) this.label.textContent = strings.soldOut || this.dataset.textSoldOut;
        if (this.buttonPrice) this.buttonPrice.hidden = true;
        return;
      }

      this.mode = 'add';
      this.button.disabled = false;
      this.button.removeAttribute('aria-disabled');

      if (this.label) this.label.textContent = this.dataset.textAddToCart;
      if (this.buttonPrice) this.buttonPrice.hidden = false;
    }

    onClick(event) {
      event.preventDefault();

      if (this.mode === 'choose') {
        const target = this.variantPicker();
        if (!target) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });

        // Move focus so keyboard and screen-reader users arrive where sighted
        // users are looking, not still on an off-screen button.
        const focusable = target.querySelector('input:not([disabled]), select, button');
        if (focusable) focusable.focus({ preventScroll: true });
        return;
      }

      if (this.mode === 'disabled' || this.busy) return;

      /*
        Adding to cart is delegated to the real buy button. Clicking it runs
        Dawn's <product-form> submit handler, which owns the fetch, error
        rendering and opening the cart drawer. This component intentionally
        has no cart implementation of its own.
      */
      const main = this.mainSubmitButton();
      if (!main) {
        if (this.dataset.productUrl) window.location.href = this.dataset.productUrl;
        return;
      }

      const phoneModels = Array.from(main.form?.elements || []).filter((field) => field.matches('[data-phone-model]'));
      if (phoneModels.some((phoneModel) => !phoneModel.value.trim())) {
        main.click();
        return;
      }

      this.setBusy(true);
      main.click();

      /* If the click never reached a live handler - product-form.js failed to
         load, or the button was disabled between syncButton() and now - no
         cart event will ever fire. Detect that immediately rather than making
         the shopper wait out the 8s safety net. */
      if (main.getAttribute('aria-disabled') === 'true' && !main.classList.contains('loading')) {
        this.setBusy(false);
        this.syncButton();
      }
    }

    /* ---------- variant changes ---------- */

    onVariantChange(event) {
      const data = event?.data;
      if (!data) return;
      /* No section filter: a product page renders exactly one <product-info>,
         and this section is enabled_on product templates only. */

      // Dawn re-renders the main section and hands us the parsed HTML. Reusing
      // its price markup keeps currency, locale and sale formatting identical
      // to the main price with no formatting code here.
      if (data.html && this.priceHost && data.sectionId) {
        const source = data.html.getElementById(`price-${data.sectionId}`);
        if (source) {
          this.priceHost.innerHTML = source.innerHTML;
          if (this.buttonPrice) {
            const currentPrice = source.querySelector('.price--on-sale .price__sale .price-item--sale')
              || source.querySelector('.price__regular .price-item--regular')
              || source.querySelector('.price__sale .price-item--sale');
            if (currentPrice) this.buttonPrice.textContent = currentPrice.textContent.trim();
          }
        }
      }

      if (this.thumb && data.variant && data.variant.featured_image && data.variant.featured_image.src) {
        this.setThumb(data.variant.featured_image.src);
      }

      /*
        data.variant بترجع null لما الاختيار الحالي مايوصلش لنسخة
        حقيقية (توليفة غير متاحة). في الحالة دي بنفضّي السطر بدل ما
        نسيب اسم نسخة قديمة غلط تحت السعر.
      */
      if (this.variantHost) {
        /* selectedIndex = -1 بيسيب القايمة فاضية بدل ما تدّي انطباع
           إن في نسخة مختارة وهي مش موجودة. */
        if (data.variant) this.variantHost.value = String(data.variant.id);
        else this.variantHost.selectedIndex = -1;
      }

      this.syncButton(data.variant ?? null);
    }

    /* ---------- الاختيار من داخل الكارت ---------- */

    onVariantPick(event) {
      const option = event.target.selectedOptions[0];
      if (!option) return;

      const picker = document.querySelector('variant-selects');
      if (!picker) return;

      /*
        الربط بالترتيب مش بالاسم. أسماء الحقول في الثيم بتطلع
        "Color-1
" بسطر جديد من الليكويد، فالمطابقة بالاسم هشّة.
        getAllSelectedOptions في global.js بيلف على نفس المجموعات
        دي بنفس الترتيب، فترتيب الأوبشن هو العقد الحقيقي.
      */
      const groups = picker.querySelectorAll('fieldset, .product-form__input--dropdown');
      const values = (option.dataset.options || '').split('~|~');
      let last = null;

      values.forEach((value, i) => {
        const group = groups[i];
        if (!group) return;

        const select = group.querySelector('select');
        if (select) {
          if (select.value === value) return;
          select.value = value;
          /*
            updateSelectionMetadata في global.js بتعمل
            .find(o => o.getAttribute('selected')).removeAttribute(...)
            من غير أي حماية — لو مفيش أوبشن شايل السمة دي بترمي
            TypeError وبيقف كل التحديث. فبنسيب واحدة مظبوطة دايمًا.
          */
          Array.from(select.options).forEach((o) => o.removeAttribute('selected'));
          if (select.selectedOptions[0]) select.selectedOptions[0].setAttribute('selected', 'selected');
          last = select;
          return;
        }

        const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find(
          (r) => r.value === value
        );
        if (!radio || radio.checked) return;
        radio.checked = true;
        last = radio;
      });

      /* حدث واحد بعد ما كل الحقول تتظبط. لو بعتنا حدث مع كل أوبشن،
         Dawn هيعمل fetch وrender لكل واحد — وأول واحد فيهم بتوليفة
         نص مظبوطة. */
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setThumb(src) {
      try {
        /* نفس القص اللي بيتطلب في الليكويد (4:5)، وإلا صورة النسخة
           بترجع بنسبتها الأصلية وتبان مختلفة عن أول تحميل. */
        const url = new URL(src, window.location.origin);
        url.searchParams.set('width', '200');
        url.searchParams.set('height', '250');
        url.searchParams.set('crop', 'center');
        this.thumb.src = url.toString();
        this.thumb.removeAttribute('srcset');
      } catch (e) {
        /* A malformed CDN URL must not take the sticky bar down with it. */
      }
    }
  }

  if (!customElements.get('ks-sticky-atc')) {
    customElements.define('ks-sticky-atc', KsStickyAtc);
  }

  } catch(e) { console.error(e); }
})();
})();
